import { render, staticRenderFns } from "./OpeningCard.vue?vue&type=template&id=4bb3f4ac&"
import script from "./OpeningCard.vue?vue&type=script&lang=js&"
export * from "./OpeningCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports